import walletApi from 'apis/walletApi';
import store, { RootState, useAppSelector } from 'cache/store';
import classNames from 'classnames';
import { BankDepositModel } from 'models/bankModel';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import styles from './deposit.styles';
import UsdtDeposit from './UsdtDeposit';
const cdnUrl = process.env.REACT_APP_CDN_URL;

interface TabDeposit {
    label: string;
    value: 'BANK' | 'QICK' | 'EWALLET' | 'USDT';
}
const tabInit: TabDeposit[] = [
    {
        label: 'Ngân hàng',
        value: 'BANK',
    },
    {
        label: 'USDT-BSC',
        value: 'USDT',
    },
];

function DepositPage() {
    const { userInfo } = useAppSelector((state: RootState) => state.auth);

    const [tabSelect, setTabSelect] = useState<'BANK' | 'QICK' | 'EWALLET' | 'USDT'>('BANK');
    const [bankTransfer, setBankTransfer] = useState<BankDepositModel[]>([]);
    const [depositSelect, setDepositSelect] = useState<BankDepositModel>({} as BankDepositModel);

    const [linkDeposit3rd, setLinkDeposit3rd] = useState('');

    useEffect(() => {
        const initDeposit = async () => {
            try {
                const { data } = await walletApi.depositInit({});
                if (!data.msg) {
                    setBankTransfer(data.bankcardlist.filter((item: BankDepositModel) => item.tabtype === 'OFFLINE'));
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            }
        };
        initDeposit();
    }, []);

    const changeTabBank = (tab: 'BANK' | 'QICK' | 'EWALLET' | 'USDT') => {
        if (tab === tabSelect) return;
        setTabSelect(tab);
        setDepositSelect({} as BankDepositModel);
        if (linkDeposit3rd) setLinkDeposit3rd('');
    };

    const changeDepositType = (banktype: BankDepositModel) => {
        if (banktype.id === depositSelect.id || banktype.isMaintain) {
            return;
        }
        setDepositSelect(banktype);
    };

    return (
        <div className={styles.wrap}>
            <div className={styles.tabList}>
                <h6 className={styles.titleDeposit}>Phương Thức Nạp Tiền: </h6>
                <div className={styles.listTab}>
                    {tabInit.map((tab) => (
                        <div className={classNames(styles.tabItem, { active: tabSelect === tab.value })} key={tab.value} onClick={() => changeTabBank(tab.value)}>
                            {tab.label}
                        </div>
                    ))}
                </div>
            </div>

            {tabSelect === 'USDT' ? (
                <UsdtDeposit />
            ) : linkDeposit3rd ? (
                <div className={styles.iframeDeposit}>
                    <iframe src={linkDeposit3rd} title="link-deposit"></iframe>
                </div>
            ) : (
                <>
                    {bankTransfer.length === 0 ? (
                        <div className={styles.noData}>Không có dữ liệu !!!</div>
                    ) : (
                        <div className={styles.bankList}>
                            {bankTransfer.map((bank) => (
                                <div className={classNames(styles.bankItem, { active: depositSelect.id === bank.id })} key={bank.id} onClick={() => changeDepositType(bank)}>
                                    <div className="check">{depositSelect.id === bank.id && <div className="checked" />}</div>
                                    <div className={styles.bankItemInner}>
                                        <img
                                            className={styles.bankIcon}
                                            src={`${cdnUrl}/bank-list/${bank.providercode === 'V8PAY' || bank.providercode === 'V8PBANKQR' ? 'v8pay.gif' : bank.icon}`}
                                            alt=""
                                        />
                                        {depositSelect.id === bank.id && <span className="corner-check"></span>}
                                    </div>
                                    {bank.isMaintain && <p className={styles.isMaintain}>Bảo trì</p>}
                                </div>
                            ))}
                        </div>
                    )}

                    {bankTransfer.length > 0 && (
                        <>
                            <div className={styles.tabList}>
                                <h6 className={styles.titleDeposit}>Thời gian xử lý: </h6>
                                <h6 className={styles.timeHandle}>2 phút</h6>
                            </div>

                            <div className={styles.viewDeposit}>
                                <div
                                    onClick={() => {
                                        if (!depositSelect.id || depositSelect.isMaintain) return;
                                        setLinkDeposit3rd(
                                            `${process.env?.REACT_APP_PAYMENT_URL}?loginname=${userInfo.loginname}&providerCode=${depositSelect.accid}&token=${encodeURIComponent(store.getState().auth.token.accessToken || '')}`
                                        );
                                    }}
                                    className={classNames(styles.btnDeposit, { [styles.btnDisabled]: !depositSelect.id || depositSelect.isMaintain })}
                                >
                                    <p>NẠP TIỀN</p>
                                </div>
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default DepositPage;
